import { TableEmptyState } from '@practium/ui';
import type { MockLandingPlan } from '../../../types/landing.types';
import styles from '../LandingTable.module.css';

interface LandingPlansTableProps {
	plans: MockLandingPlan[];
	onRowClick?: (id: string) => void;
}

export const LandingPlansTable = ({ plans, onRowClick }: LandingPlansTableProps) => {
	if (plans.length === 0) {
		return (
			<TableEmptyState
				title="Nenhum plano encontrado"
				subtitle="Indexe um plano para começar"
			/>
		);
	}

	return (
		<div className={styles.tableWrapper}>
			<table className={styles.table}>
				<thead className={styles.thead}>
					<tr>
						<th>Nome</th>
						<th>Tipo</th>
						<th>Cliques</th>
						<th>Vendas</th>
						<th>Conversão</th>
						<th>Abandono</th>
						<th>Status</th>
					</tr>
				</thead>
				<tbody className={styles.tbody}>
					{plans.map(item => (
						<tr
							key={item._id}
							onClick={() => onRowClick?.(item._id)}
							className={onRowClick ? styles.clickableRow : undefined}
						>
							<td>
								<span className={styles.cellPrimary}>{item.name}</span>
							</td>
							<td>
								<span className={styles.cellSecondary}>{item.tipo}</span>
							</td>
							<td>
								<span className={styles.cellSecondary}>{item.cliques.toLocaleString('pt-BR')}</span>
							</td>
							<td>
								<span className={styles.cellSecondary}>{item.vendas.toLocaleString('pt-BR')}</span>
							</td>
							<td>
								<span className={styles.cellSecondary}>{item.conversao}</span>
							</td>
							<td>
								<span className={styles.cellSecondary}>{item.abandono.toLocaleString('pt-BR')}</span>
							</td>
							<td>
								<span
									className={`${styles.statusBadge} ${
										item.status === 'active' ? styles.statusActive : styles.statusInactive
									}`}
								>
									{item.status === 'active' ? 'Ativo' : 'Inativo'}
								</span>
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
};
